// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"23d877a0","64":"c53cb856","83":"61a57583","216":"057d6890","223":"11f836ac","234":"b9fbbdfb","247":"55ef2b6f","272":"fe3c466b","453":"1834358c","609":"7a544eac","627":"aaa70853","808":"3b6429b1","893":"104246e6","917":"f07ecf5c"}[chunkId] + ".chunk.js";
};